import React from 'react';
import { RouteContext } from 'src/context';
import { useRouteAccess } from 'src/routes/routeAccess';
import { NoSidebarConfig, PageContent } from 'src/legacy/components/UI';
import { useDrawerWidth } from 'src/features/drawer/useDrawerWidth';

export interface PageLayoutProps {
  routeAccessCheck?: keyof ReturnType<typeof useRouteAccess>;
  noSidebar?: NoSidebarConfig;
  noToolbar?: boolean;
  fullpage?: boolean;
  noSpace?: boolean;
  unauthAccessAllowed?: boolean | keyof ReturnType<typeof useRouteAccess>;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  routeAccessCheck,
  children,
  noSidebar = 'false',
  noToolbar = false,
  fullpage = false,
  noSpace = false,
  unauthAccessAllowed = false,
}) => {
  const routeAccess = useRouteAccess();
  const drawerWidth = useDrawerWidth();
  const { pathname } = React.useContext(RouteContext);
  const isSettingsPage = pathname.startsWith('/settings');
  const allowed = routeAccessCheck ? routeAccess[routeAccessCheck] : undefined;
  const unauthAccessAllowedBool =
    typeof unauthAccessAllowed === 'string'
      ? routeAccess[unauthAccessAllowed]
      : unauthAccessAllowed;

  return (
    <PageContent
      drawerWidth={drawerWidth}
      allowed={allowed}
      noToolbar={noToolbar}
      noSidebar={noSidebar}
      fullPage={fullpage}
      noSpace={noSpace}
      isSettingsPage={isSettingsPage}
      unauthAccessAllowed={unauthAccessAllowedBool}
    >
      {children}
    </PageContent>
  );
};
